// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tooltip-hover[data-v-20ff2823] {\n  max-width: 400px;\n  margin: 0;\n  padding: 0;\n}\n\n", ""]);
// Exports
module.exports = exports;
